module.exports = __webpack_public_path__ + "static/media/quote-gen.a8cc3e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/quote-gen.png
// module id = 45
// module chunks = 0